module.exports = __webpack_public_path__ + "img/43_7.304b4915.png";